import { render, staticRenderFns } from "./VehicleItem.vue?vue&type=template&id=6926279f"
import script from "./VehicleItem.vue?vue&type=script&lang=js"
export * from "./VehicleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports